/**
 * 扩展数组方法
 */
const _ = require('lodash')


/**
 * 最大值
 */
Array.prototype.max = function() {
  return Math.max.apply({}, this)
}

/**
 * 最小值
 */
Array.prototype.min = function() {
  return Math.min.apply({}, this)
}

/**
 * 增强版indexOf
 */
Array.prototype.findIndex = function(value, fromIndex) {
  let index = -1
  try {
    if (value && typeof value == 'string') {
      index = this.indexOf(value, fromIndex)
    } else {
      index = _.findIndex(this, value, fromIndex)
    }
  } catch (e) {
    console.log('Array.findIndex Error', e)
  }

  return index
}

/**
 * 删除指定位置上的元素
 */
Array.prototype.removeByIndex = function(index) {
  try {
    if (index != -1) {
      this.splice(index, 1);
    }
  } catch (e) {
    console.log('Array.removeByIndex Error', e)
  }

  return this
}

/**
 * 删除指定元素，支持所有类型
 * 第2个参数为true，且删除元素为对象时，只要数组中对象包含value对象就会删除成功，如
 * let arr = [{name: '小A', age: 8}]
 * arr.remove({name: '小A'}) // arr = [{name: '小A', age: 8}]
 * arr.remove({name: '小A'}, true) // arr = []
 */
Array.prototype.remove = function(value, force) {
  try {
    let index = this.findIndex(value)
    this.removeByIndex(index)
  } catch (e) {
    console.log('Array.remove Error', e)
  }

  return this
}

/**
 * 去重添加，第2个参数是只按指定key去重，如按id去重添加
 * let arr = [{name: '小A', age: 8}]
 * arr.pushOnly({name: '小A', age: 8}) // arr = [{name: '小A', age: 8}]
 * arr.pushOnly({name: '小A', age: 1}) // arr = [{name: '小A', age: 8}, {name: '小A', age: 1}]
 * arr.pushOnly({name: '小A', age: 8}, {name: '小A'}) // arr = [{name: '小A', age: 8}, {name: '小A', age: 8}]
 */
Array.prototype.pushOnly = function(value, obj) {
  try {
    if (
      (obj && typeof value == 'object' && _.findIndex(this, obj) == -1) ||
      (!obj && typeof value == 'string' && this.indexOf(value) == -1) ||
      (!obj && typeof value != 'string' && this.indexOf(value) == -1 && _.findIndex(this, value) == -1)
    ) {
      this.push(value)
    }
  } catch (e) {
    console.log('Array.pushOnly Error', e)
  }

  return this
}

/**
 * 用法同pushOnly
 */
Array.prototype.unshiftOnly = function(value, obj) {
  try {
    if (
      (obj && typeof value == 'object' && _.findIndex(this, obj) == -1) ||
      (!obj && typeof value == 'string' && this.indexOf(value) == -1) ||
      (!obj && typeof value != 'string' && this.indexOf(value) == -1 && _.findIndex(this, value) == -1)
    ) {
      this.unshift(value)
    }
  } catch (e) {
    console.log('Array.unshiftOnly Error', e)
  }

  return this
}
